import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userConfig: {
    email: "",
    fullname: "",
    superAdminId: "",
    logged: false,
    logoutPending: false,
    language: "es",
    literals: [],
    rol: null,
    token: null,
    componentActive: "dashboard",
    datatable: { configuration: { maxRows: 12, indexStart: 0, pages: [0], filterBy: { section: "", filter: [] } }, checkColumn: false },
    alert: {
      called: false,
      title: "",
      message: "",
      type: "normal",
    },
    floatPanel: {
      visible: false,
      queryId: null,
      isEmpty: true,
      data: {},
    },
  },
};

const userConfigSlice = createSlice({
  name: "aplicationConfig",
  initialState,
  reducers: {
    setAlert: (state, action) => {
      state.userConfig.alert = action.payload;
    },
    setUserLogged: (state, action) => {
      const { logged, token, rol, email, fullname, superAdminId } = action.payload;
      state.userConfig.logged = logged;
      state.userConfig.rol = rol;
      state.userConfig.token = token;
      state.userConfig.email = email;
      state.userConfig.fullname = fullname;
      state.userConfig.superAdminId = superAdminId;
    },
    // Kept for backwards compatibility with existing components.
    setUserRol: (state, action) => {
      state.userConfig.rol = action.payload;
    },
    // Kept for backwards compatibility with existing components.
    setToken: (state, action) => {
      state.userConfig.token = action.payload;
    },
    setUserLogOut: (state) => {
      const { language, literals } = state.userConfig;
      state.userConfig = { ...initialState.userConfig, language, literals };
    },
    setLogoutPending: (state, action) => {
      state.userConfig.logoutPending = action.payload;
    },
    setUserLanguage: (state, action) => {
      state.userConfig.language = action.payload;
    },
    setLanguage: (state, action) => {
      state.userConfig.literals = action.payload;
    },
    setComponentActive: (state, action) => {
      state.userConfig.floatPanel.visible = false;
      state.userConfig.componentActive = action.payload;
    },
    updateDatatableConfiguration: (state, action) => {
      state.userConfig.datatable.configuration = action.payload;
    },
    updateDatatableFilter: (state, action) => {
      const { section, filter } = action.payload;
      state.userConfig.datatable.configuration.filterBy.section = section;
      state.userConfig.datatable.configuration.filterBy.filter = filter;
    },
    updateDatatableCheckColumn: (state, action) => {
      state.userConfig.datatable.checkColumn = typeof action.payload === "boolean" ? action.payload : !state.userConfig.datatable.checkColumn;
    },
    updateFloatPanel: (state, action) => {
      const { visible, queryId, isEmpty, data = {} } = action.payload;
      state.userConfig.floatPanel.visible = visible;
      state.userConfig.floatPanel.queryId = queryId;
      state.userConfig.floatPanel.isEmpty = isEmpty;
      state.userConfig.floatPanel.data = data;
    },
  },
});

export const {
  setUserLogged,
  setUserLanguage,
  setLanguage,
  setUserRol,
  setComponentActive,
  updateDatatableConfiguration,
  setToken,
  setUserLogOut,
  setLogoutPending,
  setAlert,
  updateDatatableFilter,
  updateDatatableCheckColumn,
  updateFloatPanel,
} = userConfigSlice.actions;
export default userConfigSlice.reducer;
